import { render, staticRenderFns } from "./ScreenFormatos.vue?vue&type=template&id=4f8992a2"
import script from "./ScreenFormatos.vue?vue&type=script&lang=js"
export * from "./ScreenFormatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports